import { render, staticRenderFns } from "./SelectNevoIngredient.vue?vue&type=template&id=4de5c082&scoped=true"
import script from "./SelectNevoIngredient.vue?vue&type=script&lang=js"
export * from "./SelectNevoIngredient.vue?vue&type=script&lang=js"
import style0 from "./SelectNevoIngredient.vue?vue&type=style&index=0&id=4de5c082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5c082",
  null
  
)

export default component.exports